/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Oto_Cta_NoteInputs */

const en_simple_oto_cta_note = /** @type {(inputs: Simple_Oto_Cta_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`First plan is free. No card needed.`)
};

const id_simple_oto_cta_note = /** @type {(inputs: Simple_Oto_Cta_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rencana pertama gratis. Tidak perlu kartu kredit.`)
};

/**
* | output |
* | --- |
* | "First plan is free. No card needed." |
*
* @param {Simple_Oto_Cta_NoteInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_oto_cta_note = /** @type {((inputs?: Simple_Oto_Cta_NoteInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Oto_Cta_NoteInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_oto_cta_note(inputs)
	return en_simple_oto_cta_note(inputs)
});